import React, { ForwardRefExoticComponent, PropsWithChildren, RefAttributes } from 'react';

import styles from './dropdown.scss';

type DropdownProps = RefAttributes<HTMLDivElement> & PropsWithChildren;

export const Dropdown: ForwardRefExoticComponent<DropdownProps> = React.forwardRef<
  HTMLDivElement,
  DropdownProps
>(({ children }, ref) => {
  return (
    <div ref={ref} className={styles.wrapper}>
      {children}
    </div>
  );
});

Dropdown.displayName = 'Dropdown';
